export default "__VITE_ASSET__d4ee6090__"